import { escapeHtml } from '../utils/index.js';

type PageHeroProps = {
  label: string;
  title: string;
  intro: string;
  kicker: string;
  stack: string[];
};

type PageCtaProps = {
  label: string;
  title: string;
  body: string;
  buttonLabel: string;
  href?: string;
  compact?: boolean;
  sectionClassName?: string;
  sectionAttrs?: string;
};

export function renderPageHero(props: PageHeroProps): string {
  const { label, title, intro, kicker, stack } = props;

  return `
    <section class="page-hero page-hero-split">
      <div class="container page-hero-grid">
        <div class="animate-on-scroll">
          <p class="page-hero-label">${escapeHtml(label)}</p>
          <h1 class="page-hero-title">${escapeHtml(title)}</h1>
          <p class="page-hero-intro">${escapeHtml(intro)}</p>
        </div>
        <div class="page-hero-aside animate-on-scroll">
          <p class="page-hero-aside-kicker">${escapeHtml(kicker)}</p>
          <div class="page-hero-stack">
            ${stack.map((item) => `<span>${escapeHtml(item)}</span>`).join('')}
          </div>
        </div>
      </div>
    </section>
  `;
}

export function renderPageCta(props: PageCtaProps): string {
  const {
    label,
    title,
    body,
    buttonLabel,
    href = '/contact-us',
    compact = false,
    sectionClassName = 'section',
    sectionAttrs = '',
  } = props;

  return `
    <section class="${escapeHtml(sectionClassName)}"${sectionAttrs ? ` ${sectionAttrs}` : ''}>
      <div class="container cta-panel animate-on-scroll${compact ? ' cta-panel-compact' : ''}">
        <div>
          <p class="section-kicker">${escapeHtml(label)}</p>
          <h2 class="section-title light">${escapeHtml(title)}</h2>
          <p class="section-intro light">${escapeHtml(body)}</p>
        </div>
        <div class="cta-panel-actions">
          <a href="${escapeHtml(href)}" class="btn-primary">${escapeHtml(buttonLabel)}</a>
        </div>
      </div>
    </section>
  `;
}
